module.exports = __webpack_public_path__ + "static/media/newlogo.bc9e1588.svg";